import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { ArrayType } from '@angular/compiler';
@Injectable()
export class MasterDataService {
  private baseApiUrl: string;
  private additionalData: any;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient,
    private translateService:TranslateService
  ) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getAll(dataList: Array<string>, parameterList: any = null): Observable<any> {
    return this.httpClient.post(`${this.baseApiUrl}masterdata`,
      { dataList, parameterList }).pipe(
        map((res: any) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


private translateResponse(response: any , dataList: string[]): any {

    const translatedResponse = {...response};
    console.log('Master data to be translated', translatedResponse,dataList);

    for (const key in translatedResponse) {
      if (translatedResponse.hasOwnProperty(key) && Array.isArray(translatedResponse[key])) {
        translatedResponse[key].additionalData=dataList[key];
        //console.log('currentItem',translatedResponse);
       }}

      for (const key in translatedResponse) {
        if (translatedResponse.hasOwnProperty(key)) {
          if(translatedResponse[key].additionalData !=='Remarks' && translatedResponse[key].additionalData !=='TransactionAuthoriser' && translatedResponse[key].additionalData !== 'CasaScheme' && translatedResponse[key].additionalData !=='ShareScheme'&& translatedResponse[key].additionalData !=='TermDepositScheme' && translatedResponse[key].additionalData !=='LoanScheme'
          && translatedResponse[key].additionalData !== 'Currency'
          && translatedResponse[key].additionalData !== 'GeneralLedger'
          && translatedResponse[key].additionalData !== 'UnusedLiabilityLedgers'
          && translatedResponse[key].additionalData !== 'IncomeGeneralLedger'
          && translatedResponse[key].additionalData !== 'ExpenseGeneralLedger'
          && translatedResponse[key].additionalData !== 'LiabilityGeneralLedger'
          && translatedResponse[key].additionalData !== 'UnusedAssetLedgers'
          && translatedResponse[key].additionalData !== 'AssetGeneralLedger'
          && translatedResponse[key].additionalData !== 'UnusedAssetLedgers'
          && translatedResponse[key].additionalData !== 'IncomeGeneralLedgerForiegnCurrency'
          && translatedResponse[key].additionalData !== 'ExpenseGeneralLedgerForiegnCurrency'
          && translatedResponse[key].additionalData !== 'UnusedLiabilityLedgersForeignCurrency'
          && translatedResponse[key].additionalData !== 'LiabilityLedgersForeignCurrency'
          && translatedResponse[key].additionalData !== 'LiabilityLedgers'
          && translatedResponse[key].additionalData !== 'AssetGeneralLedgerForiegnCurrency'
          && translatedResponse[key].additionalData !== 'AssetAllGeneralLedger'
          && translatedResponse[key].additionalData !== 'LiabilityAllGeneralLedger'
          && translatedResponse[key].additionalData !=='GroupLoanScheme'){
          for (let i = 0; i < translatedResponse[key].length; i++) {
           // console.log('translatedResponse[key]',translatedResponse[key]);
            const translationKey = 'MASTER_DATA.DROP_DOWN_' + translatedResponse[key][i].name.toUpperCase();
          this.translateService.get(translationKey).subscribe((translatedName: string) => {
          translatedResponse[key][i].name = translatedName;
          });
          }
        }
        delete translatedResponse[key].additionalData;
        }
      }


    console.log('Master data After translated',translatedResponse);
    return translatedResponse;
  }
}

export class MasterData {
  readonly KYCAccountType = 'KYCAccountType';
  readonly SearchPurpose = 'SearchPurposeList';
  readonly EmployerIndustry = 'EmployerIndustry';
  readonly Salary = 'Salary';
  readonly LoanPurposeType = 'LoanPurposeType';
  readonly OccupationClass = 'OccupationClass';
  readonly PropertyDensity = 'PropertyDensity';
  readonly PropertyOwnership = 'PropertyOwnership';
  readonly AddressProofType = 'AddressProofType';
  readonly AddressType = 'AddressType';
  readonly ApplicationSourceType = 'ApplicationSourceType';
  readonly ApplicationModule = 'ApplicationModule';
  readonly CasteCategory = 'CasteCategory';
  readonly Citizenship = 'Citizenship';
  readonly Gender = 'Gender';
  readonly GeneralLedgerPurpose = 'GeneralLedgerPurpose';
  readonly IdProofType = 'IdProofType';
  readonly LoanInterestFrequency = 'LoanInterestFrequency';
  readonly CasaInterestFrequency = 'CasaInterestFrequency'; 
  readonly InterestRateModification = 'InterestRateModification';
  readonly LoanInterestType = 'LoanInterestType';
  readonly KycType = 'KycType';
  readonly LoanPurpose = 'LoanPurpose';
  readonly MaritalStatus = 'MaritalStatus';
  readonly NamePrefix = 'NamePrefix';
  readonly Occupation = 'Occupation';
  readonly PenalInterestFormula = 'PenalInterestFormula';
  readonly PhoneType = 'PhoneType';
  readonly PrioritySectorMainPurpose = 'PrioritySectorMainPurpose';
  readonly PrioritySectorSubPurpose = 'PrioritySectorSubPurpose';
  readonly ProcessingFeeType = 'ProcessingFeeType';
  readonly RebateFormula = 'RebateFormula';
  readonly RelatedPersonType = 'RelatedPersonType';
  readonly Religion = 'Religion';
  readonly AccountType = 'AccountType';
  readonly AccountOperation = 'AccountOperation';
  readonly Remarks = 'Remarks';
  readonly LoanProcess = 'LoanProcess';
  readonly LoanRepaymentType = 'LoanRepaymentType';
  readonly DepositInterestType = 'DepositInterestType';
  readonly WeakerSection = 'WeakerSection';
  readonly DividendFormula = 'DividendFormula';
  readonly LoanDisbursementType = 'LoanDisbursementType';
  readonly TransferType = 'TransferType';
  readonly ChequeLeafProcess = 'ChequeLeafProcess';
  readonly ODStatus = 'ODStatus';
  readonly TypeofODLimit = 'TypeofODLimit';
  readonly TDInterestPaymentMode = 'TDInterestPaymentMode';
  readonly TDInterestCalculationType = 'TDInterestCalculationType';
  readonly ClgInstrumentType = 'ClgInstrumentType';
  readonly ClgProcessStatus = 'ClgProcessStatus';
  readonly ChequePrefix = 'ChequePrefix';
  readonly ResidentialStatus = 'ResidentialStatus';
  readonly LoanOtherCharges = 'LoanOtherCharges';
  readonly Relationship = 'Relationship';
  readonly LinkedType = 'LinkedType';
  readonly AccountHolderType = 'AccountHolderType';
  readonly DepositTypes = 'DepositTypes';
  readonly RDFrequency = 'RDFrequency';
  readonly TDInterestType = 'TDInterestType';
  readonly TDInterestFrequency = 'TDInterestFrequency';
  readonly penaltyFeeType = 'penaltyFeeType';
  readonly InterestRateFor = 'InterestRateFor';
  readonly OverdraftScheme = 'OverdraftScheme';
  readonly OverdraftPurpose = 'OverdraftPurpose';
  readonly InstrumentType = 'InstrumentType';
  readonly ChequeValidationType = 'ChequeValidationType';
  readonly ExternalBank = 'ExternalBank';
  readonly ChequeRejectReason = 'ChequeRejectReason';
  readonly MaturityInstruction = 'MaturityInstruction';
  readonly LienType = 'LienType';
  readonly CommissionType = 'CommissionType';
  readonly GH15 = 'GH15';
  readonly AppraiserType = 'AppraiserType';
  readonly RDInstallmentType = 'RDInstallmentType';
  readonly RDInterestType = 'RDInterestType';
  readonly PigmyWithdrawalType = 'PigmyWithdrawalType';
  readonly PigmyInstructionType = 'PigmyInstructionType';
  readonly KYCFeedbackType = 'KYCFeedbackType';
  readonly CollectionSourceType = 'CollectionSourceType';
  readonly MachineType = 'MachineType';
  readonly RDDepositType = 'RDDepositType';
  readonly RDInterestFrequency = 'RDInterestFrequency';
  readonly NPAConsideration = 'NPAConsideration';
  readonly NPAFrequency = 'NPAFrequency';
  readonly NPAType = 'NPAType';

  readonly Branch = 'Branch';
  readonly GeneralLedger = 'GeneralLedger';
  readonly LoanScheme = 'LoanScheme';
  readonly CasaScheme = 'CasaScheme';
  readonly ShareScheme = 'ShareScheme';
  readonly UnusedAssetLedgers = 'UnusedAssetLedgers';
  readonly UnusedLiabilityLedgers = 'UnusedLiabilityLedgers';
  readonly UnusedIncomeLedgers = 'UnusedIncomeLedgers';
  readonly UnusedExpenseLedgers = 'UnusedExpenseLedgers';
  readonly TermDepositScheme = 'TermDepositScheme';
  readonly ClearingScheme = 'ClearingScheme';
  readonly PigmyScheme = 'PigmyScheme';
  readonly Appraisers = 'Appraisers';
  readonly RecurringDepositScheme = 'RecurringDepositScheme';

  readonly SharesGeneralLedger = 'SharesGeneralLedger';
  readonly ReserveFundGeneralLedger = 'ReserveFundGeneralLedger';
  readonly BorrowingsGeneralLedger = 'BorrowingsGeneralLedger';
  readonly SavingsAccountGeneralLedger = 'SavingsAccountGeneralLedger';
  readonly CurrentAccountGeneralLedger = 'CurrentAccountGeneralLedger';
  readonly FixedDepositGeneralLedger = 'FixedDepositGeneralLedger';
  readonly ReInvestmentGeneralLedger = 'ReInvestmentGeneralLedger';
  readonly RecurringDepositFixedGeneralLedger = 'RecurringDepositFixedGeneralLedger';
  readonly RecurringDepositVariableGeneralLedger = 'RecurringDepositVariableGeneralLedger';
  readonly PigmyGeneralLedger = 'PigmyGeneralLedger';
  readonly OtherLiabilitiesGeneralLedger = 'OtherLiabilitiesGeneralLedger';
  readonly DDPOGeneralLedger = 'DDPOGeneralLedger';
  readonly NEFTGeneralLedger = 'NEFTGeneralLedger';
  readonly DividendGeneralLedger = 'DividendGeneralLedger';
  readonly CashGeneralLedger = 'CashGeneralLedger';
  readonly BankAccountGeneralLedger = 'BankAccountGeneralLedger';
  readonly InvestmentGeneralLedger = 'InvestmentGeneralLedger';
  readonly LoanRBMGeneralLedger = 'LoanRBMGeneralLedger';
  readonly LoanEMIGeneralLedger = 'LoanEMIGeneralLedger';
  readonly LoanFlatGeneralLedger = 'LoanFlatGeneralLedger';
  readonly OverdraftGeneralLedger = 'OverdraftGeneralLedger';
  readonly OtherAssetsGeneralLedger = 'OtherAssetsGeneralLedger';
  readonly AssetGeneralLedger = 'AssetGeneralLedger';
  readonly LiabilityGeneralLedger = 'LiabilityGeneralLedger';
  readonly IncomeGeneralLedger = 'IncomeGeneralLedger';
  readonly ExpenseGeneralLedger = 'ExpenseGeneralLedger';
  readonly TransactionAuthoriser = 'TransactionAuthoriser';
   readonly Currency = 'Currency';
    readonly LoanRecoveryType = 'LoanRecoveryType';
  readonly WeeklyHoliday = 'WeeklyHoliday';
  readonly MicroFinanceCenter = 'MicroFinanceCenter';
  readonly MicroFinanceGroup = 'MicroFinanceGroup';
  readonly AreaCode = 'AreaCode';
  readonly Profession = 'Profession';
  readonly DocumentType='DocumentType';
  readonly CustomerCategory='CustomerCategory';
  readonly CustomerType='CustomerType';
  readonly ClientType='ClientType';
  readonly CompanyType='CompanyType';
  readonly OrganizationType='OrganizationType';
  readonly LoanDocumentType='LoanDocumentType';
  readonly ModuleType='ModuleType';
  readonly IBTAsset='IBTAsset';
  readonly IBTLiability='IBTLiability';
  readonly GLBranchType='GLBranchType';
   readonly DeleteTransactionType='DeleteTransactionType';
   readonly UnusedCasaLiabilityLedgers='UnusedCasaLiabilityLedgers';
   readonly UnusedShareLiabilityLedgers='UnusedShareLiabilityLedgers';
   readonly UnusedLoanAssetLedgers='UnusedLoanAssetLedgers';
  readonly AllBankGL='AllBankGL';
  readonly LiabilityBankGeneralLedger='LiabilityBankGeneralLedger';
  readonly InterfaceTransactionType='InterfaceTransactionType';
  readonly AssetCashGeneralledger = 'AssetCashGeneralledger';
readonly ApprovalType  ='ApprovalType ';
  readonly SpecialLoanAuthoriseDocumentType = 'SpecialLoanAuthoriseDocumentType';
  readonly District = 'District';
  readonly ProofIdType = 'ProofIdType';
  readonly ConstitutionType = 'ConstitutionType';
  readonly CountryCode = 'CountryCode';
  readonly CountryStateCode = 'CountryStateCode';
  readonly KycCategory = 'KycCategory';
  readonly RelationWithYambukai = 'RelationWithYambukai';
  readonly RelatedPersonNonEntityType = 'RelatedPersonNonEntityType';
  readonly legalProofOfIdentityType = 'legalProofOfIdentityType';
  readonly DocumentProofIdentityType = 'DocumentProofIdentityType';
  readonly NonProofOfIdentityType = 'NonProofOfIdentityType';
  readonly CitizenshipNonEntity = 'CitizenshipNonEntity';
  readonly LoanSchemeForCharge = 'LoanSchemeForCharge';
  readonly CasaSchemeForCharge = 'CasaSchemeForCharge';
  readonly LoanChargesType = 'LoanChargesType';
  readonly CasaChargesType = 'CasaChargesType';
  readonly GetAllBankLedgers = 'GetAllBankLedgers';
  readonly InterfaceChannelType = 'InterfaceChannelType';
  readonly InterfaceSourceType = 'InterfaceSourceType';
  readonly LocalCurrencyGl = 'LocalCurrencyGl';
  readonly OtherCurrencyGl = 'OtherCurrencyGl';
  readonly ChargeTo = 'ChargeTo';
  readonly TransactionFrequency = 'TransactionFrequency';
  readonly TaxBasis = 'TaxBasis';
  readonly EwalletTransactionLimit = 'EwalletTransactionLimit';
  readonly InterfaceMapping = 'InterfaceMapping';
  readonly InvoiceStatus = 'InvoiceStatus';
  readonly InvoiceFrequency = 'InvoiceFrequency';
  readonly SetupChargeType = 'SetupChargeType';
  readonly VehicleDocumentType = 'VehicleDocumentType';
  readonly LandDocumentType = 'LandDocumentType';
  readonly InsuranceDocumentType = 'InsuranceDocumentType';
  readonly GoldDocumentType = 'GoldDocumentType';
  readonly EmployeDocumentType ='EmployeDocumentType';
  readonly AssetBankGeneralLedger ='AssetBankGeneralLedger';  
  readonly  ExcecutionRule='ExcecutionRule';
  readonly StandingInstructionType='StandingInstructionType';
  readonly ProcessStatus = 'ProcessStatus';
  readonly CustomerCollateralType = 'CustomerCollateralType';
  readonly ArchivedType = 'ArchivedType';
  
}

